// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3U5J7","label":"Completed_label__3Gqfo"};